module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "posts-by-user"
  }, [(_vm.posts && _vm.posts.length > 0) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.posts[0].poster.firstName) + " " + _vm._s(_vm.posts[0].poster.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "well clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    attrs: {
      "src": _vm.posts[0].poster.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', [_vm._v(_vm._s(_vm.posts[0].poster.firstName) + " " + _vm._s(_vm.posts[0].poster.lastName))]), _vm._v(" "), (_vm.posts[0].poster.title) ? _c('h4', [_vm._v(_vm._s(_vm.posts[0].poster.title))]) : _vm._e(), _vm._v(" "), (_vm.posts[0].poster.socialLinks) ? _c('ul', {
    staticClass: "social-links"
  }, _vm._l((_vm.posts[0].poster.socialLinks), function(value, propertyName) {
    return _c('li', [_c('a', {
      attrs: {
        "href": value,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(propertyName))])])
  })) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.posts) ? _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "list-group posts"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return _c('li', {
      staticClass: "clearfix"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'thread',
          params: {
            forumId: post.forumId,
            topicId: post.topicId,
            postId: post.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.truncate(post.body))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_vm._v("\n                            " + _vm._s(post.topicTitle) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("shortDate")(post.createdAt)) + "\n                        ")])])], 1)
  })], 2), _vm._v(" "), (_vm.totalPages > 1) ? _c('ul', {
    staticClass: "forum-pagination"
  }, [_c('li', [_c('a', {
    staticClass: "previous-page",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("«")])]), _vm._v(" "), _vm._l((_vm.totalPages), function(i) {
    return _c('li', [_c('a', {
      class: {
        'current-page': i === (_vm.currentPage + 1)
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentPage = (i - 1)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(i) + "\n                        ")])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "previous-page",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("»")])])], 2) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Recent Posts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "header forum-header clearfix"
  }, [_c('div', {
    staticClass: "col-xs-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v("Post")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_vm._v("Thread")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_vm._v("Posted on")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c277ebb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostsByUser.vue
// module id = 1980
// module chunks = 2